<template>
	<window-view title="Opdater" v-on="$listeners" :width="400" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<select-view v-model="m.toVersion" :options="_versions" label="Version" />
				</grid-view>			
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import client from '../../../model/client';

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				id: '',
				m: client.updateModel(),
				versions: [],
			};
		},
		computed: {
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							return self.submit(this.m);
						}
					}
				];
			},
			_versions() {
				return this.versions.map(val => {
					return {
						label: val.id,
						value: val.id,
					};
				});
			},
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};

			this.versions = (await this.axios.get('/versions?_size=1000')).data.content;
		}
	}
</script>

<style lang="scss" scoped>

</style>
